import Vue from "vue";

export const EventBus = new Vue();

export const notify = (message, status) => {
  if (message && message.status === 401) {
    // handled by unauthorized-interceptor: session cleared, back to login
    return;
  }
  EventBus.$emit("newNotification", {
    message: message,
    type: status,
  });
};
